import { render, staticRenderFns } from "./AppointmentTable.vue?vue&type=template&id=22a91072&scoped=true&"
import script from "./AppointmentTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentTable.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTable.vue?vue&type=style&index=0&id=22a91072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a91072",
  null
  
)

export default component.exports